<main class="dashboard">
  <app-header (onShowSideBar)="showSideBar()"></app-header>
  <app-sidebar [parentClass]="sideBarClass" (onCloseSideBar)="closeSideBar()"></app-sidebar>
  <div class="dashboard__content">
    <router-outlet></router-outlet>
  </div>
</main>
